const McpServerActions = {
  PUBLIC_SERVER_LIST_LOADED: "public-mcp-server-list/loaded",
};

export default McpServerActions;
